import { render } from "./topTitle.vue?vue&type=template&id=3f928c6e&scoped=true"
const script = {}

import "./topTitle.vue?vue&type=style&index=0&id=3f928c6e&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f928c6e"]])

export default __exports__